import { useLocation, useParams } from 'react-router-dom';

import { AssertionDescriptorUsageTypesEnum } from '../../utilities/Constants';
import { DocumentTitle } from '../../components/shared/DocumentTitle';
import { IPackageSettlementModel } from '../../interfaces/ICase';
import { Loader } from '../../components/shared/Loader';
import PackageSettlementDetail from '../case/packagesettlement/PackageSettlementDetail';
import { useAuthContext } from '../../contexts/AuthContext';
import { useZoneContext } from '../../contexts/useZoneContext';
import { useZoneGetAssertionDescriptors } from '../../shared/react-query-hooks/useZoneGetAssertionDescriptors';

function PackageSettlementDetailExportWrapper() {
    const { guid } = useParams();
    const { user } = useAuthContext();
    const location: { state: any } = useLocation();
    const zoneContext = useZoneContext();

    const caseAssertionDescriptorsApi = useZoneGetAssertionDescriptors(
        AssertionDescriptorUsageTypesEnum.Case
    );

    const packageDealAssertionDescriptorsApi = useZoneGetAssertionDescriptors(
        AssertionDescriptorUsageTypesEnum.PackageDeal
    );

    let redirect = false;
    let newPackageSettlementStateFromRedirectedComponent: IPackageSettlementModel = {
        notes: [],
        locked: false,
        earliestSettledResolutionDate: '',
        valueAddDetails: [],
    };
    let selectedGuidsForFromRedirectedComponent: string[] = [];

    if (location.state) {
        newPackageSettlementStateFromRedirectedComponent =
            location.state.redirectComponentCurrentState;
        selectedGuidsForFromRedirectedComponent = location.state.selectedGuids;
        redirect = location.state.redirect;
    }

    const isLoading =
        caseAssertionDescriptorsApi.isFetching || packageDealAssertionDescriptorsApi.isFetching;

    return (
        <>
            <DocumentTitle title="Package Deal" />

            {isLoading ? (
                <Loader />
            ) : (
                <PackageSettlementDetail
                    caseAssertionDescriptors={caseAssertionDescriptorsApi.data ?? []}
                    packageDealAssertionDescriptors={packageDealAssertionDescriptorsApi.data ?? []}
                    guid={guid ?? ''}
                    user={user}
                    selectedGuids={selectedGuidsForFromRedirectedComponent}
                    redirect={redirect}
                    redirectComponentCurrentState={
                        redirect ? newPackageSettlementStateFromRedirectedComponent : undefined
                    }
                    zoneContext={zoneContext}
                />
            )}
        </>
    );
}

export default PackageSettlementDetailExportWrapper;
